import React from 'react';
import { useMarkets } from "../../../../data";
import MarketsContext from "./MarketsContext";
var MarketsProvider = function MarketsProvider(_ref) {
  var children = _ref.children;
  var _useMarkets = useMarkets(),
    markets = _useMarkets.markets,
    isLoadingMarkets = _useMarkets.isLoadingMarkets;
  var value = {
    data: markets,
    isLoading: isLoadingMarkets
  };
  return /*#__PURE__*/React.createElement(MarketsContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement("div", null, children));
};
export default MarketsProvider;